module.exports = __webpack_public_path__ + "img/app-hamburger-menu.4ac26c51.png";